"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountViewAllTemplatesButton = exports.ViewAllTemplatesButton = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ViewAllTemplatesButton = function (props) {
    return (react_1.default.createElement(kaleidoscope_1.Button, { className: "view-all-templates-btn", onClick: props.onClick, type: kaleidoscope_1.ButtonType.Secondary },
        "View all ",
        react_1.default.createElement(icons_1.ArrowRight, null)));
};
exports.ViewAllTemplatesButton = ViewAllTemplatesButton;
var mountViewAllTemplatesButton = function (mountReactComponent, handleClick) {
    return mountReactComponent(react_1.default.createElement(exports.ViewAllTemplatesButton, { onClick: handleClick }));
};
exports.mountViewAllTemplatesButton = mountViewAllTemplatesButton;
